import axios from 'axios'
import store from '../store'
import {clientIdFromAccessToken} from './clientId'

import {
  MOVEMENT_ALARMS_REPORT_TIME,
  MISSION_FAIL_REPORT_TIME,
  VEHICLES_IN_A_MISSION,
  CURRENT_DATE_TIME_CO,
  CURRENT_CONDITION_REPORT,
  LAST_EVENT_REPORT,
  IN_MISSION,
  UNREPORTED_EVENTS_ALARMS,
  FENCES_FROM_GEO,
  FENCES,
  MISSIONS_SERVICES,
  MOVEMENT_ALARMS,
  GENERAL_JUSTIFICATION_ALARM,
  JUSTIFICATION_ALARM,
  POINT_DATA,
  MISSIONS_TEMPLATES,
  VALID_STATUSES,
  DEFAULT_REASONS,
  SPEED_TIME_REPORT,
  MISSIONS_ALARMS,
  SPEED_ALARMS,
  TIME_REPORT,
  POINT_REPORT,
  VEHICLES_TYPE,
  VEHICLES_CURRENT,
  AGENCIES_TREE,
  LAST_POSITIONS_URL,
  VEHICLES_URL,
  GEO_URL,
  GEOFENCES_URL,
  MISSIONS_URL,
  ALERTS_URL,
  AGENCIES,
  GEO_ACTIVE_MISSION,
  PARKING_ALARMS,
  GEOFENCE_IN_ALARMS,
  PARKING_ALARM_REPORT_TIME,
  VEHICLES_WITHOUT_EVENTS_3H_ALARMS,
  MISSIONS_BASE,
  LOGS_HISTORY,
  LOGS_HISTORY_REPORT,
  GEOFENCE_IN_ALARM_REPORT_VEHICLE,
  GEOFENCE_IN_ALARM_REPORT_TIME,
  STATIC_HEATMAP,
  DYNAMIC_HEATMAP
} from './endpoints'

axios.defaults.headers.common['Content-type'] = 'application/json'
axios.defaults.headers.common['Accept'] = 'application/json'
axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('accessToken')}`
axios.defaults.params = {}
axios.defaults.params['idToken'] = localStorage.getItem('idToken')

// ***************************************
// --------------- MISSIONS
// ***************************************
// --------------- MISSIONS SERVICES
export function fetchMissionsServices(payload) {
  return axios.get(MISSIONS_SERVICES, { params: payload })
}

// --------------- MISSIONS TEMPLATES
export function fetchMissionsTemplates() {
  return axios.get(MISSIONS_TEMPLATES)
}

// ***************************************
// --------------- BINNACLE
// ***************************************
// --------------- VEHICLE STATUSES
export function updateVehicleCondition(payload) {
  return axios.post(`${VEHICLES_URL}/${payload.id}/statuses`, {
    name: payload.name,
    translatedName: payload.translatedName,
    observations: payload.observations,
    reason: payload.reason,
    anotherReason: payload.anotherReason,
    ticket: payload.ticket,
    time: payload.time
  })
}
export function fetchDefaultReasons() {
  return axios.get(DEFAULT_REASONS)
}

export function fetchValidStatuses() {
  return axios.get(VALID_STATUSES)
}

// ***************************************
// --------------- ALARMS
// ***************************************
// --------------- VEHICLES WITHOUT REPORT ALARMS
export function fetchUnreportedEventsAlarms() {
  return axios.get(`${UNREPORTED_EVENTS_ALARMS}`)
}

// --------------- MOVEMENT ALARMS
export function fetchMovementAlarms() {
  return axios.get(`${MOVEMENT_ALARMS}`)
}

// --------------- GENERAL JUSTIFICATION ALARMS
export function justificationGeneralAlarm(data) {
  const sendData = {
    justifiableType: data.justifiableType,
    justifiableId: data.alarmId,
    isJustified: data.isJustified,
    observations: data.observations
  }
  return axios.post(GENERAL_JUSTIFICATION_ALARM, sendData)
}

// --------------- JUSTIFICATION ALARMS
export function justificationAlarm(data) {
  const sendData = {
    isJustified: data.isJustified,
    observations: data.observations
  }
  return axios.post(`${JUSTIFICATION_ALARM}/${data.alarmId}/justification`, sendData)
}

// --------------- MISSION ALARMS
export function fetchMissionAlarms() {
  return axios.get(MISSIONS_ALARMS)
}

// --------------- SPEED ALARMS
export function fetchSpeedAlarms() {
  // return axios.get(`${SPEED_ALARMS}?perPage=200`)
  return axios.get(SPEED_ALARMS)
}

// --------------- GEOFENCE IN ALARMS
export function fetchGeofenceInAlarms() {
  return axios.get(GEOFENCE_IN_ALARMS)
}

// export function setSpeedAlarmsPage(page) {
//   return axios.get(`${SPEED_ALARMS}?page=${page}&perPage=200`)
// }

export function fetchParkingAlarms() {
  return axios.get(PARKING_ALARMS)
}

export function fetchVehicleWithoutEvents3hAlarms() {
  return axios.get(VEHICLES_WITHOUT_EVENTS_3H_ALARMS)
}
// ***************************************
// --------------- REPORTS
// ***************************************
export function getReportMovementAlarmsVehicle(payload) {
  return axios.get(`${VEHICLES_URL}/${payload.id}/movement-alarms/report`, {params: payload.params})
}

export function getReportMovementAlarmsTime(payload) {
  return axios.get(MOVEMENT_ALARMS_REPORT_TIME, {params: payload})
}

export function getReportMissionFailVehicle(payload) {
  return axios.get(`${VEHICLES_URL}/${payload.id}/missions/failed/report`, {params: payload.params})
}

export function getReportMissionFailTime(payload) {
  return axios.get(MISSION_FAIL_REPORT_TIME, {params: payload})
}

export function getCurrentConditionReport() {
  return axios.get(CURRENT_CONDITION_REPORT)
}

export function getLastEventReport(payload) {
  const params = payload.agencyId !== null
    ? { agencyId: payload.agencyId }
    : {}
  return axios.get(LAST_EVENT_REPORT, { params })
}

export function getPointData(payload) {
  return axios.get(POINT_DATA, {
    params: {
      date1: payload.date1,
      date2: payload.date2,
      lat: payload.lat,
      lng: payload.lng,
      radius: payload.radius,
      agencies: payload.agencies
    }
  })
}

export function getSpeedVehicleReport(payload) {
  // console.log('API getSpeedVehicleReport', payload)
  const id = payload.id
  const fromDate = `${payload.date1} ${payload.time1Date1}`
  let toDate
  if (payload.date2 !== null) toDate = `${payload.date2} ${payload.time1Date2}`
  else toDate = `${payload.date1} ${payload.time2Date1}`
  // console.log('API getSpeedVehicleReport fromDate', fromDate)
  // console.log('API getSpeedVehicleReport toDate', toDate)

  return axios.get(`${VEHICLES_URL}/${id}/speed-alerts/report`, {
    params: {
      'from_date': fromDate,
      'to_date': toDate,
      'duration': payload.duration,
      'limit': payload.limit
    }
  })
}

export function getSpeedTimeReport(payload) {
  const params = {
    'from_date': payload.fromDate,
    'to_date': payload.toDate,
    'duration': payload.duration,
    'limit': payload.limit
  }
  if (payload.agencyId) params['agency_id'] = payload.agencyId
  return axios.get(`${SPEED_TIME_REPORT}`, { params })
}

// export function getTimeReport({id, date1 = null, time1Date1 = null, time2Date1 = null, date2 = null, time1Date2 = null}) {
export function getTimeReport({id, date1 = null, time1Date1 = null, date2 = null, time1Date2 = null}) {
  const fromDate = `${date1} ${time1Date1}:00`
  const toDate = `${date2} ${time1Date2}:00`
  return axios.get(`${TIME_REPORT}/${id}/positions/report`, {
  // return axios.get(`https://strauss-test.seguridadenlinea.com/v1/ai/testingdata/${id}`, {
    params: {
      fromDate,
      toDate
    }
    // responseType: 'blob'
  })
}

export function getPointReport(payload) {
  return axios.get(POINT_REPORT, {
    params: {
      date1: payload.date1,
      date2: payload.date2,
      lat: payload.lat,
      lng: payload.lng,
      radius: payload.radius
    },
    responseType: 'blob'
  })
}

export function getReportParkingAlarmsTime(payload) {
  return axios.get(PARKING_ALARM_REPORT_TIME, {params: payload})
}

export function getReportParkingAlarmsVehicle(payload) {
  return axios.get(`${VEHICLES_URL}/${payload.id}/parking-alarms/report`, {params: payload.params})
}

export function getLogHistoryReport(payload) {
  const startDate = payload.startDate
  const endDate = payload.endDate
  return axios.get(`${LOGS_HISTORY_REPORT}?startDate=${startDate}&endDate=${endDate}`)
}

export function getGeofenceInAlarmReportVehicle(payload) {
  return axios.get(`${GEOFENCE_IN_ALARM_REPORT_VEHICLE}/${payload.id}/missions/inside/report`, {params: payload.params})
}

export function getGeofenceInAlarmReportTime(payload) {
  return axios.get(GEOFENCE_IN_ALARM_REPORT_TIME, {params: payload})
}

// ***************************************
// --------------- AGENCIES
// ***************************************
export function deleteAgency(id) {
  return axios.delete(`${AGENCIES}/${id}`)
}

export function updateAgency(payload) {
  return axios.put(`${AGENCIES}/${payload.id}`, {
    name: payload.name
  })
}
export function createAgency(payload) {
  return axios.post(AGENCIES, {
    name: payload.name,
    parentId: payload.id
  })
}

export function fetchAgenciesTree() {
  return axios.get(AGENCIES_TREE)
}

// --------------- VEHICLE
export function fetchPathsViewerByPoint(payload) {
  const date1 = payload.date1
  const date2 = payload.date2
  const time1Date1 = payload.time1Date1
  const time2Date1 = payload.time2Date1
  const time1Date2 = null
  const requests = []
  const vehiclesId = payload.vehiclesId

  vehiclesId.forEach(id => {
    // requests.push(axios.get(`https://strauss.seguridadenlinea.com/v1/avl/vehicles/${id}/positions`, {
    requests.push(axios.get(`${VEHICLES_URL}/${id}/positions`, {
      params: {
        date1,
        date2,
        time1Date1,
        time2Date1,
        time1Date2
      }
    }))
  })
  // console.log('REQUESTS', requests)
  return axios.all(requests)
}

export function fetchVehicleTypes() {
  return axios.get(VEHICLES_TYPE)
}

export function currentVehicles() {
  return axios.get(VEHICLES_CURRENT)
}

export function lastPositions() {
  return axios.get(LAST_POSITIONS_URL)
}

export function updateVehicle(id, vehicleDataTemp, chipSerialYesNot) {
  // console.log('updateVehicle', id, vehicleDataTemp, chipSerialYesNot)
  if (!chipSerialYesNot) vehicleDataTemp['fuelChip'] = null
  return axios.put(`${VEHICLES_URL}/${id}`, vehicleDataTemp)
}

export function fetchVehicles() {
  return axios.get(VEHICLES_URL)
}

export function fetchVehicleById(id) {
  return axios.get(`${VEHICLES_URL}/${id}`)
}

// --------------- PLACE
function zoneClientId() {
  const mode = store.getters['auth/mapZoneMode']
  if (mode === 'gobernacion') return 2
  return clientIdFromAccessToken()
}

export function getPlace({lat, lng, clientId, type}) {
  return axios.get(`${GEO_URL}/areas`, {
    params: {
      lat,
      lng,
      type: type || 'neighborhood,quadrant,commune,policeStation,policeDistrict,municipality,firefightersDivision',
      client_id: clientId || zoneClientId()
    }
  })
}

// --------------- ZONES
export function fetchZonesByIds(idsArray) {
  const mode = store.getters['auth/mapZoneMode']
  if (mode === 'all') {
    return Promise.all([1, 2].map(clientId => {
      return axios.get(`${GEO_URL}/search?id=${idsArray}&client_id=${clientId}`)
    })).then(responses => {
      const byId = new Map()
      responses.forEach(response => {
        const rows = Array.isArray(response.data) ? response.data : []
        rows.forEach(item => byId.set(item.id, item))
      })
      return {data: Array.from(byId.values())}
    })
  }
  return axios.get(`${GEO_URL}/search?id=${idsArray}&client_id=${zoneClientId()}`)
}

export function queryZonesByType(type, value) {
  return axios.get(`${GEO_URL}/search?${type}=${value}&version=2&client_id=${zoneClientId()}`)
}

export function queryZonesByText(value) {
  return axios.get(`${GEO_URL}/search?query=${value}&client_id=${zoneClientId()}`)
}

// --------------- POSITIONS

export function filterPositionsByVehicleId({id, date1 = null, time1Date1 = null, time2Date1 = null, date2 = null, time1Date2 = null}) {
// export function filterPositionsByVehicleId({id, startDate = null, page = 1, from = null, to = null}) {
  // return axios.get(`https://strauss.seguridadenlinea.com/v1/avl/vehicles/${id}/positions`, {
  return axios.get(`${VEHICLES_URL}/${id}/positions`, {
    params: {
      date1,
      // page: page,
      time1Date1,
      time2Date1,
      date2,
      time1Date2
    }
  })
}

export function loadMorePositions(data) {
  return axios.get(data)
}

// --------------- GEOFENCES
// --------- READ
export function fetchGeofences() {
  return axios.get(FENCES_FROM_GEO)
}

// --------- READ
export function fetchGeofenceByID(id) {
  return axios.get(`${GEOFENCES_URL}/${id}`)
}

// --------- CREATE
// export function createGeofence({name, polygon, geostring}) {
export async function createGeofence({name, polygon, agencies}) {
  const responseCGF = await axios.post(GEOFENCES_URL, {
    name,
    // geostring,
    polygon
  })
  // console.log('responseCGF', responseCGF)

  const statusResponseGeo = responseCGF.status

  if (statusResponseGeo === 201) {
    const geoId = responseCGF.data.id
    const geoName = responseCGF.data.name

    const dataGF = await axios.post(FENCES, { geoName, geoId, agencies })
    // console.log('dataGF', dataGF)
    if (dataGF.status !== 204) console.error('No se pudo relacionar los datos con la nueva Cerca creada', dataGF.status)
  } else alert('No se pudo crear la Cerca. Por favor intentelo nuevamente.')

  return responseCGF
}

// --------- UPDATE
export async function editGeofence({id, name = null, polygon = null}) {
  let updateObject = {id}
  if (name !== null) {
    updateObject = {
      ...updateObject,
      name
    }
  }
  if (polygon !== null) {
    updateObject = {
      ...updateObject,
      polygon
      // geostring
    }
  }
  const responseEGF = await axios.put(`${GEOFENCES_URL}/${id}`, updateObject)
  // console.log('responseEGF', responseEGF)

  if (responseEGF.status === 200) {
    const geoId = responseEGF.data.id
    const geoName = responseEGF.data.name

    const dataEGF = await axios.post(FENCES, { geoName, geoId })
    // console.log('dataEGF', dataEGF)
    if (dataEGF.status !== 204) console.error('No se pudo relacionar los datos con la nueva Cerca creada', dataEGF.status)
  } else alert('No se pudo editar la Cerca. Por favor intentelo nuevamente.')

  return responseEGF
}

// ***************************************
// --------------- MISSIONS
// ***************************************
// VEHICLES IN A MISSION
export function getVehiclesInAMission(id) {
  return axios.get(`${VEHICLES_IN_A_MISSION}/${id}`)
}
// MODIFY WHERE
export function modifyWhereMission({id, where, modifiedWhy}) {
  const data = {
    where,
    modifiedWhy
  }
  return axios.put(`${MISSIONS_URL}/${id}/where`, data)
}
// MODIFY WHEN
export function modifyDatesMission({id, when, modifiedWhy}) {
  const data = {
    dates: when.dates,
    time: when.time,
    // time: {
    //   start: '00:00',
    //   end: '00:00'
    // },
    modifiedWhy
  }
  return axios.put(`${MISSIONS_URL}/${id}/dates`, data)
}
// MODIFY WHO
export function modifyVehiclesMission({id, vehicles, modifiedWhy}) {
  const data = {
    who: vehicles,
    modifiedWhy
  }
  return axios.put(`${MISSIONS_URL}/${id}/vehicles`, data)
}
// DELETE
export function deleteMission({id, deletedWhy}) {
  return axios.delete(`${MISSIONS_URL}/${id}`, {params: {deletedWhy}})
}
// TERMINATE
export function terminateMission({id, terminatedWhy}) {
  const data = {
    terminatedWhy
  }
  return axios.post(`${MISSIONS_URL}/${id}/terminate`, data)
}

export function fetchInMission() {
  const cancelTokenSource = axios.CancelToken.source()
  store.dispatch('setCancelTokenInMissionData', cancelTokenSource)
  return axios.get(`${IN_MISSION}`, {
    cancelToken: cancelTokenSource.token
  })
}

export function fetchMissionById(id) {
  return axios.get(`${MISSIONS_URL}/${id}`)
}

export async function createMission(payload) {
  // console.log('CREATE MISSION', payload)
  let parentId = null

  for (const element of payload) {
    element.parentId = parentId
    const result = await axios.post(MISSIONS_URL, element)
    // console.log('RESULT', result, parentId)
    parentId = result.data.id
  }

  return true

  // const arrayPost = []
  // payload.forEach(element => {
  //   arrayPost.push(axios.post(MISSIONS_URL, element))
  // })
  // console.log('ARRAY POST: ', arrayPost)
  // return axios.all(arrayPost)
}

export function geoActiveMission(id) {
  return axios.get(`${GEO_ACTIVE_MISSION}?polygonId=${id}`)
}

// MISSIONS BASE
export function createBaseMission(payload) {
  return axios.post(MISSIONS_BASE, payload)
}

// --------------- ALERTS

export function fetchAlerts() {
  return axios.get(ALERTS_URL)
}

export function fetchAlertsByIds(ids = '') {
  return axios.get(`${ALERTS_URL}/search?ids=${ids}`)
}

// ***************************************
// --------------- DATE & TIME
// ***************************************
export function getCurrentDateTime() {
  return axios.get(CURRENT_DATE_TIME_CO)
}

// ***************************************
// --------------- LOGS HISTORY
// ***************************************
export function setLogHistory(payload) {
  return axios.post(LOGS_HISTORY, payload)
}

// ***************************************
// --------------- HEAT MAP
// ***************************************
export function getStaticHeatmap(payload) {
  const fullRequest = payload.agencySelected
    ? `${STATIC_HEATMAP}?date=${payload.date}&agencyId=${payload.agencySelected}`
    : `${STATIC_HEATMAP}?date=${payload.date}`
  return axios.get(fullRequest)
}
export function getDynamicHeatmap(payload) {
  const fullRequest = payload.agencySelected
    ? `${DYNAMIC_HEATMAP}?date=${payload.date}&agencyId=${payload.agencySelected}`
    : `${DYNAMIC_HEATMAP}?date=${payload.date}`
  return axios.get(fullRequest)
}



// WEBPACK FOOTER //
// ./src/utils/api.js